import { render, staticRenderFns } from "./SkeletonList.vue?vue&type=template&id=0880d517&scoped=true"
import script from "./SkeletonList.vue?vue&type=script&lang=js"
export * from "./SkeletonList.vue?vue&type=script&lang=js"
import style0 from "./SkeletonList.vue?vue&type=style&index=0&id=0880d517&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0880d517",
  null
  
)

export default component.exports